import { render, staticRenderFns } from "./TableSelectNew.vue?vue&type=template&id=1922e4f3&scoped=true&"
import script from "./TableSelectNew.vue?vue&type=script&lang=js&"
export * from "./TableSelectNew.vue?vue&type=script&lang=js&"
import style0 from "./TableSelectNew.vue?vue&type=style&index=0&id=1922e4f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1922e4f3",
  null
  
)

export default component.exports